// src/api/authApi.ts
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || "https://api.flavourchaser.co";

export interface LoginResponse {
  token: string;
  name: string;
  email: string;
  location_id: number;
  role?: string;
}

export const login = async (
  email: string, 
  password: string, 
  rememberMe: boolean
): Promise<LoginResponse> => {
  const response = await axios.post(
    `${API_BASE}/auth/login`,
    {
      email,
      password,
      rememberMe,
    },
    {
      withCredentials: true,
    }
  );
  
  return response.data;
};